<template>
	<div>
		<myheader :backFlag="true" headTitle="印模图片"></myheader>
		<div class="header_extend_main" style="height: 100%;">
			<div class="header_extend_back" style="height: 3rem;"></div>
			<div class="header_extend_content margin_top_5">
				<div class="all_tips_content_card_padding8">
					<div class="text12 textcolor333 font_weight_bold">{{'印模名称：'+signetInfo.signetName}}</div>
					<div class="text12 textcolor333 font_weight_bold margin_top_5 ">
						{{'印模类型：'+signetInfo.signetTypeText}}
					</div>
					<div class="text12 textcolor333 font_weight_bold margin_top_5 ">
						{{'印模图片：'}}
						<span
							:class="{'textcolorRed':signetInfo.signetImg.signetImgStatus === 2,'textcolor666':signetInfo.signetImg.signetImgStatus === 3}">
							{{signetInfo.signetImg.signetImgStatus === 2?'已启用':signetInfo.signetImg.signetImgStatusText}}</span>
					</div>
					<div v-if="signetInfo.signetImg.signetImgStatus === 3"
						class="text12 textcolor333 font_weight_bold margin_top_5 ">
						{{'未通过原因：'}}
						<span class="textcolorRed">{{signetInfo.signetImg.auditMemo}}</span>
					</div>
					<div v-if="signetInfo.signetImg"
						style="width: 90%;height: 8.4rem;border-radius: .2rem;border: 1px solid #999;margin: .5rem 5%;padding:0.2rem ;">
						<div class="display_flex" style="justify-content: center;">
							<div style="width: 8rem; height: 8rem;position: relative;" class="backgroundC_white">
								<img id="img" style="width: 8rem; height: 8rem; object-fit: fill;"
									:src="'data:image/png;base64,'+signetInfo.signetImg.signetFileBase64">
							</div>
						</div>
					</div>
				</div>
				<div class="all_tips_bottom_card">
					<button class="all_button22 width_100 text16 bmain_active" @click="exit()">关闭</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	export default {
		name: 'addsignet',
		data() {
			return {
				//
				signetId: '',
				//印模信息
				signetInfo: '',
			}
		},
		methods: {
			//印模信息
			getEditSignet() {
				this.$store.dispatch(this.$LoadShow, true)
				this.$get("/corp/api/getEditSignet", {
					signetId: this.signetId
				}).then(res => {
					this.$store.dispatch(this.$LoadShow, false)
					if (res.success && res.data) {
						if (!res.data.signetTypeText) {
							switch (res.data.signetType) {
								case 1:
									res.data.signetTypeText = '合同专用章'
									break;
								case 2:
									res.data.signetTypeText = '收货确认章'
									break;
								case 3:
									res.data.signetTypeText = '交货确认章'
									break;
								case 4:
									res.data.signetTypeText = '企业公章'
									break;
								case 5:
									res.data.signetTypeText = '人事专用章'
									break;
								case 6:
									res.data.signetTypeText = '招标专用章'
									break;
								case 7:
									res.data.signetTypeText = '非招标专用章'
									break;
							}
						}
						this.signetInfo = res.data
					} else {
						this.$Toast('获取印模信息失败！');
					}
				}).catch(err => {
					this.$store.dispatch(this.$LoadShow, false)
					this.$Toast('获取印模信息失败！');
					console.log('getNewSignet', err)
				})
			},
			//初始化
			init() {
				this.signetInfo = this.$store.state.signetInfo
				// this.signetId = this.$route.query.signetId
				// this.getEditSignet()
			},
		},
		mounted() {
			this.init()
		}
	}
</script>

<style scoped lang="scss">
	@import "../../styles/global.css";
</style>